var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.134 0 0 3.134 0 7V35C0 38.866 3.134 42 7 42H35C38.866 42 42 38.866 42 35V7C42 3.134 38.866 0 35 0H7ZM9.08594 9H17.0234L22.6602 17.0098L29.5 9H32L23.7891 18.6133L33.9141 33H25.9785L19.4375 23.707L11.5 33H9L18.3086 22.1035L9.08594 9ZM12.9141 11L27.0215 31H30.0859L15.9785 11H12.9141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterWhite);
export default __webpack_public_path__ + "static/media/twitter-white.2ff92fc3c6dbcfcb2ac9edecc1b9ba84.svg";
export { ForwardRef as ReactComponent };